export const EMPTY_PALETTE: number[] = [0, 0, 0, 0]
export const EMPTY_PALETTE_ID = ''
